import React, { useState, useEffect, useRef } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import ViewProduct from '../Master/ViewProduct';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import ProductBatch from './ProductBatch';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { fetchSupplierData, fetchProductData, removeRow, acceptNumber } from '../../services/NewPurchaseOrderService';
import { fetchGRNProducts, handleChange, handleConfirmGRN, handleInputChange, validateConfirmGrnForm } from '../../services/ConfirnGRNService';
import CustomDateInput from '../CommonComp/CustomDateInput';

const ConfirmGRN = () => {
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [supplierData, setSupplierData] = useState([]);
  const [preSupplierData, setPreSupplierData] = useState();
  const [productData, setProductData] = useState([]);
  const [grnItems, setGRNItems] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [purchaseData, setPurchaseData] = useState([]);
  const confirmModal = useRef(null);
  const [productBatch, setProductBatch] = useState([]);
  const [stdGoods, setStdGoods] = useState(0);
  const [vatAmt, setVatAmt] = useState(0);
  const [zeroGoods, setZeroGoods] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const { id } = useParams();
  const navigateToPOHistory = useNavigate();
  const [productInputValue, setProductInputValue] = useState('');
  const [picker, setSelectedProduct] = useState('');
  const accessToken = localStorage.getItem('accessToken');
  const productBatchRef = useRef(null);
  const [selectedProductId, setSelectedProductId] = useState(null);

  const [canSavePartial, setCanSavePartial] = useState(true);

  // Delivery address edit state
  const [isAddressEditMode, setIsAddressEditMode] = useState(false);
  const [deliveryAddress, setDeliveryAddress] = useState({
    addr1: '',
    addr2: '',
    city: '',
    state: '',
    country: '',
    postcode: ''
  });

  // Warehouse edit state
  const [isWarehouseEditMode, setIsWarehouseEditMode] = useState(false);
  const [warehouseData, setWarehouseData] = useState({
    warehouse_name: '',
    code: '',
    addr1: '',
    addr2: '',
    city: '',
    state: '',
    country: '',
    postcode: ''
  });

  const [modalData, setModalData] = useState(null);
  const [arrivalDate, setArrivalDate] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [formData, setFormData] = useState({
    arrival_date: '',
    job_ref: '',
    notes: ''
  });
  const [fieldErrors, setFieldErrors] = useState({});

  const handleOpenPastPurchaseModal = (data) => {
    setModalData(data);
    if (productBatchRef.current) {
      productBatchRef.current();

    }
  };

  // Form data handlers
  const handleFormDataChange = (field, value) => {
    let error = '';
    if (field === 'job_ref') {
      if (!String(value).trim()) {
        error = 'Job Ref is required';
      } else if (value.length > 50) {
        error = 'Max 50 characters allowed';
      }
    }
    if (field === 'notes' && value.length > 500) {
      error = 'Max 500 characters allowed';
    }
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setFieldErrors(prev => ({ ...prev, [field]: error }));
  };

  // Update hidden fields when data changes
  useEffect(() => {
    if (purchaseData && purchaseData.delivery_type) {
      $('#delivery_type').val(purchaseData.delivery_type);
    }
    if (purchaseData && purchaseData.purchase_id) {
      $('#purchase_id').val(purchaseData.purchase_id);
    }
    if (warehouseData && warehouseData.warehouse_id) {
      $('#warehouse_id').val(warehouseData.warehouse_id);
    }
  }, []);

  // Update form fields with address and warehouse data
  useEffect(() => {
    // Update address fields
    if (deliveryAddress.addr1) $('#addr1').val(deliveryAddress.addr1);
    if (deliveryAddress.addr2) $('#addr2').val(deliveryAddress.addr2);
    if (deliveryAddress.city) $('#city').val(deliveryAddress.city);
    if (deliveryAddress.state) $('#state').val(deliveryAddress.state);
    if (deliveryAddress.country) $('#country').val(deliveryAddress.country);
    if (deliveryAddress.postcode) $('#postcode').val(deliveryAddress.postcode);

    // Update warehouse fields
    if (warehouseData.warehouse_name) $('#warehouse_name').val(warehouseData.warehouse_name);
    if (warehouseData.code) $('#wcode').val(warehouseData.code);
    // Set formData for job_ref and notes from purchaseData
    setFormData(prev => ({
      ...prev,
      job_ref: purchaseData.job_ref || '',
      notes: purchaseData.notes || '',
      arrival_date: purchaseData.arrival_date || ''
    }));
  }, [purchaseData, deliveryAddress, warehouseData]);

  useEffect(() => {
    fetchSupplierData(setSupplierData);
    fetchProductData(setProductData);
    fetchGRNProducts(id, setGRNItems, setPurchaseData, setBatchData, setStdGoods, setPreSupplierData, setDeliveryAddress, setWarehouseData);
    // console.log(batchData); 
  }, []);

  // Debug supplier data
  useEffect(() => {
    console.log('Supplier Data:', supplierData);
    console.log('Pre Supplier Data:', preSupplierData);
    console.log('Supplier Data Length:', supplierData ? supplierData.length : 0);
    console.log('Supplier Options:', supplierData && supplierData.length > 0 ? supplierData.map(item => ({
      value: item.id,
      label: item.name
    })) : []);
  }, [supplierData, preSupplierData]);

  useEffect(() => {
    const roundMoney = (n) => Math.round((Number(n) || 0) * 100) / 100;

    const receiptQty = (row) => parseFloat(row.batchQty) || 0;

    const totalVat = grnItems.reduce((total, row) => {
      const cost = parseFloat(row.cost) || 0;
      const qty = receiptQty(row);
      const vatPct = parseFloat(row.vat_percentage) || 0;
      if (qty <= 0 || vatPct <= 0) {
        return total;
      }
      return total + cost * qty * (vatPct / 100);
    }, 0);

    const stdGoodsTotal = grnItems.reduce((total, row) => {
      if (parseFloat(row.vat) > 0 || parseFloat(row.vat_percentage) > 0) {
        const cost = parseFloat(row.cost) || 0;
        const qty = receiptQty(row);
        return total + cost * qty;
      }
      return total;
    }, 0);

    const zeroGoodsTotal = grnItems.reduce((total, row) => {
      const vatPct = parseFloat(row.vat_percentage) || 0;
      const vatField = parseFloat(row.vat) || 0;
      if (vatPct === 0 && vatField === 0) {
        const cost = parseFloat(row.cost) || 0;
        const qty = receiptQty(row);
        return total + cost * qty;
      }
      return total;
    }, 0);

    const stdR = roundMoney(stdGoodsTotal);
    const zeroR = roundMoney(zeroGoodsTotal);
    const vatR = roundMoney(totalVat);

    setStdGoods(stdR);
    setZeroGoods(zeroR);
    setVatAmt(vatR);
    setGrandTotal(roundMoney(stdR + zeroR + vatR));
  }, [grnItems]);

  const getProductBatchData = async (id) => {
    try {
      const formData = new FormData();
      formData.set('product_id', id);

      const response = await axios.post(
        `${config.api_url}/ws-batch-info-by-product-id`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const data = response.data;
      setProductBatch(data.batch);
      handleOpenPastPurchaseModal(data.batch);

    } catch (error) {
      console.error("Error fetching product batch data:", error);
    }
  };

  const addExpiryField = (rowIndex) => {
    const newGRNItems = [...grnItems];
    newGRNItems[rowIndex].expiry_dates.push("");
    setGRNItems(newGRNItems);
  };

  const handleProductChange = (inputValue) => {
    setSelectedProduct(inputValue);
  };

  const handleChange_confirm_grn = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      setProductInputValue(selectedOption);
      handleChange(selectedOption.value, grnItems, setGRNItems);
      console.log(grnItems);
    } else {
      setProductInputValue(null);
      console.warn("Selected option is invalid or missing a value");
    }
  };

  const addExpiryData = (itemId) => {
    setGRNItems(prevItems => {
      const currentItem = prevItems.find(item => item.id === itemId);
      if (!currentItem) return prevItems;

      // Calculate remaining order quantity (order_qty - grn)
      const remainingOrderQty = currentItem.order_qty - currentItem.grn;

      // Calculate current total batch quantity
      const currentTotalBatchQty = currentItem.expiryData.reduce((total, data) => total + (parseFloat(data.batchQty) || 0), 0);

      // Check if we can add more expiry rows (only if there's remaining quantity)
      if (currentTotalBatchQty >= remainingOrderQty) {
        Swal.fire({
          title: "Warning!",
          text: `Cannot add more expiry rows. Total batch quantity (${currentTotalBatchQty}) already equals or exceeds remaining order quantity (${remainingOrderQty}).`,
          icon: "warning",
          timer: 3000,
          showConfirmButton: false,
        });
        return prevItems; // Return unchanged state
      }

      return prevItems.map(item =>
        item.id === itemId
          ? {
            ...item,
            expiryData: [...item.expiryData, { expiryDate: "", batchQty: "" }]
          }
          : item
      );
    });
  };

  const handleExpiryChange = (e, rowIndex, expiryIndex) => {
    const newGRNItems = [...grnItems];
    newGRNItems[rowIndex].expiry_dates[expiryIndex] = e.target.value;
    setGRNItems(newGRNItems);
  };

  const handleChange = (e, index, field) => {
    const newValue = field === 'expiryDate' ? e.target.value : acceptNumber(e.target.value);

    // If this is a batchQty field, validate against remaining order quantity
    if (field === 'batchQty') {
      const currentBatchItem = batchData[index];
      if (currentBatchItem) {
        const currentBatchQty = parseFloat(newValue) || 0;

        // Find the corresponding GRN item
        const grnItem = grnItems.find(item => item.product_id === currentBatchItem.product_id);
        if (grnItem) {
          // Calculate remaining order quantity (order_qty - grn)
          const remainingOrderQty = grnItem.order_qty - grnItem.grn;

          // Calculate total batch quantity excluding current index
          const otherBatchQtys = batchData
            .map((item, i) => i !== index && item.product_id === currentBatchItem.product_id ? (parseFloat(item.qty) || 0) : 0)
            .reduce((total, qty) => total + qty, 0);

          const totalBatchQty = otherBatchQtys + currentBatchQty;

          // Check if total batch quantity exceeds remaining order quantity
          if (totalBatchQty > remainingOrderQty) {
            Swal.fire({
              title: "Error!",
              text: `Total batch quantity (${totalBatchQty}) cannot exceed remaining order quantity (${remainingOrderQty}). Please enter a smaller quantity.`,
              icon: "error",
              timer: 3000,
              showConfirmButton: false,
            });
            return; // Don't update the state
          }
        }
      }
    }

    setBatchData(prevBatchData => {
      const updatedBatchData = [...prevBatchData];
      if (updatedBatchData[index]) {
        updatedBatchData[index] = {
          ...updatedBatchData[index],
          [field === 'expiryDate' ? 'expiry_date' : 'qty']: newValue
        };
      }
      return updatedBatchData;
    });
  };

  const handleExpiryDataChange = (e, itemId, index, field) => {
    var newValue = '';
    if (field === 'expiryDate') {
      newValue = e.target.value;
    }
    else {
      newValue = acceptNumber(e.target.value);
    }

    setGRNItems(prevItems => {
      const currentItem = prevItems.find(item => item.id === itemId);
      if (!currentItem) return prevItems;

      // Calculate remaining order quantity (order_qty - grn)
      const remainingOrderQty = currentItem.order_qty - currentItem.grn;

      // If this is a batchQty field, validate against remaining order quantity
      if (field === 'batchQty') {
        const currentBatchQty = parseFloat(newValue) || 0;

        // Calculate total batch quantity excluding current index
        const otherBatchQtys = currentItem.expiryData
          .map((data, i) => i !== index ? (parseFloat(data.batchQty) || 0) : 0)
          .reduce((total, qty) => total + qty, 0);

        const totalBatchQty = otherBatchQtys + currentBatchQty;

        // Check if total batch quantity exceeds remaining order quantity
        if (totalBatchQty > remainingOrderQty) {
          Swal.fire({
            title: "Error!",
            text: `Total batch quantity (${totalBatchQty}) cannot exceed remaining order quantity (${remainingOrderQty}). Please enter a smaller quantity.`,
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
          });
          return prevItems; // Return unchanged state
        }
      }

      const updatedItems = prevItems.map(item =>
        item.id === itemId
          ? {
            ...item,
            expiryData: item.expiryData.map((data, i) =>
              i === index
                ? {
                  ...data,
                  [field]: newValue,
                }
                : data
            )
          }
          : item
      );

      // Step 2: Calculate the total batch quantity after the update
      const totalBatchQty = updatedItems.find(item => item.id === itemId).expiryData.reduce((total, data) => total + (parseFloat(data.batchQty) || 0), 0);

      // Step 3: Update the batchQty for the item
      return updatedItems.map(item =>
        item.id === itemId
          ? {
            ...item,
            batchQty: totalBatchQty, // Set the total batch quantity
            received_qty: totalBatchQty
          }
          : item
      );
    });
  };

  const removeExpiryData = (itemId, index) => {
    setGRNItems(prevItems => {
      const currentItem = prevItems.find(item => item.id === itemId);
      if (!currentItem) return prevItems;

      // Calculate remaining order quantity (order_qty - grn)
      const remainingOrderQty = currentItem.order_qty - currentItem.grn;

      // Step 1: Filter out the expired data entry
      const updatedItems = prevItems.map(item =>
        item.id === itemId
          ? {
            ...item,
            expiryData: item.expiryData.filter((_, i) => i !== index)
          }
          : item
      );

      // Step 2: Calculate the total batch quantity after the removal
      const totalBatchQty = updatedItems.find(item => item.id === itemId)?.expiryData.reduce((total, data) => total + (parseFloat(data.batchQty) || 0), 0) || 0;

      // Step 3: Update the batchQty for the item
      return updatedItems.map(item =>
        item.id === itemId
          ? {
            ...item,
            batchQty: totalBatchQty, // Set the total batch quantity
            received_qty: totalBatchQty
          }
          : item
      );
    });
  };

  useEffect(() => {
    $('#dsTable tbody').off('click', '.applybtn');
    $('#dsTable tbody').on('click', '.applybtn', function () {
      $('#freestock').empty();
      $('#stock').empty();
      $('#on_so').empty();
      $('#allocation').empty();
      $('#onpf').empty();
      $('#onpo').empty();
      const product_id = $(this).data('id');
      const formData = new FormData();
      formData.append('id', product_id);
      document.getElementById('viewProductForm').reset();
      const fetchProductData = async () => {
        const apiUrl = `${config.api_url}/ws-get-products-by-id`;
        try {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              'Authorization': `Bearer ${accessToken}`
            },
            body: formData,
          });

          const data = await response.json();
          $('#code').val(data.products[0].code);
          $('#packValue').val(data.products[0].pack);
          $('#vat').val(data.products[0].vat);
          $('#weight').val(data.products[0].gross_weight);
          $('#supplier').val(data.products[0].supplier_name);
          $('#description').val(data.products[0].product_desc);
          $('#sizeValue').val(data.products[0].size);
          $('#barcode').val(data.products[0].unit_barcode);
          $('#view_case_barcode').val(data.products[0].case_barcode);
          $('#pallet_qty').val(data.products[0].pallet_qty);
          $('#case_price').val(data.products[0].price);
          $("#product_status").html(data.products[0].status != 0
            ? 'Status : <span style="margin-left: 5px;" class="badge bg-success">Active</span>'
            : 'Status : <span style="margin-left: 5px;" class="badge bg-secondary"> Inactive</span>'
          );
          $('#viewcbm').val(data.products[0].cbm);
          $('#brandname').val(data.products[0].brand);
          $('#categooryName').val(data.products[0].category);
          $('#editnetWeight').val(data.products[0].net_weight);
          $('#editgrossWeight').val(data.products[0].gross_weight);
          $('#freestock').append(data.freestock == null ? 0 : data.freestock);
          $('#stock').append(parseInt(data.products[0].quantity));
          $('#on_so').append(data.onso == null ? 0 : data.onso);
          $('#allocation').append(data.allocation == null ? 0 : data.allocation);
          $('#onpf').append(data.pf == null ? 0 : data.pf);
          $('#onpo').append(data.on_purchase == null ? 0 : data.on_purchase);
        }
        catch (error) {
          console.error("Error fetching product data:", error);
        }
      };
      fetchProductData();
    });

    return () => {
      $('#dsTable tbody').off('click', '.applybtn');
    };
  }, []);

  // Address edit functions
  const toggleAddressEditMode = () => {
    setIsAddressEditMode(!isAddressEditMode);
  };

  const handleAddressChange = (field, value) => {
    setDeliveryAddress(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const saveDeliveryAddress = async () => {
    try {
      const formData = new FormData();
      formData.append("grn_id", id);
      formData.append("addr1", deliveryAddress.addr1);
      formData.append("addr2", deliveryAddress.addr2);
      formData.append("city", deliveryAddress.city);
      formData.append("state", deliveryAddress.state);
      formData.append("country", deliveryAddress.country);
      formData.append("postcode", deliveryAddress.postcode);

      const apiUrl = `${config.api_url}/ws-update-grn-delivery-address`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        alert('Delivery address updated successfully');
        setIsAddressEditMode(false);
        // Update the form fields with new values
        $("#addr1").val(deliveryAddress.addr1);
        $("#addr2").val(deliveryAddress.addr2);
        $("#city").val(deliveryAddress.city);
        $("#state").val(deliveryAddress.state);
        $("#country").val(deliveryAddress.country);
        $("#postcode").val(deliveryAddress.postcode);
      } else {
        alert(result.message || 'Failed to update delivery address');
      }
    } catch (error) {
      console.error("Error updating delivery address:", error);
      alert('Failed to update delivery address');
    }
  };

  const cancelAddressEdit = () => {
    setIsAddressEditMode(false);
    // Reset address data to original values from form fields
    setDeliveryAddress({
      addr1: $("#addr1").val() || '',
      addr2: $("#addr2").val() || '',
      city: $("#city").val() || '',
      state: $("#state").val() || '',
      country: $("#country").val() || '',
      postcode: $("#postcode").val() || ''
    });
  };

  // Warehouse edit functions
  const toggleWarehouseEditMode = () => {
    setIsWarehouseEditMode(!isWarehouseEditMode);
  };

  const handleWarehouseChange = (field, value) => {
    setWarehouseData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const saveWarehouseData = async () => {
    try {
      const formData = new FormData();
      formData.append("grn_id", id);
      formData.append("warehouse_name", warehouseData.warehouse_name);
      formData.append("code", warehouseData.code);
      formData.append("addr1", warehouseData.addr1);
      formData.append("addr2", warehouseData.addr2);
      formData.append("city", warehouseData.city);
      formData.append("state", warehouseData.state);
      formData.append("country", warehouseData.country);
      formData.append("postcode", warehouseData.postcode);

      const apiUrl = `${config.api_url}/ws-update-grn-warehouse`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        alert('Warehouse data updated successfully');
        setIsWarehouseEditMode(false);
        // Update the form fields with new values
        $("#warehouse_name").val(warehouseData.warehouse_name);
        $("#wcode").val(warehouseData.code);
        $("#addr1").val(warehouseData.addr1);
        $("#addr2").val(warehouseData.addr2);
        $("#city").val(warehouseData.city);
        $("#state").val(warehouseData.state);
        $("#country").val(warehouseData.country);
        $("#postcode").val(warehouseData.postcode);
      } else {
        alert(result.message || 'Failed to update warehouse data');
      }
    } catch (error) {
      console.error("Error updating warehouse data:", error);
      alert('Failed to update warehouse data');
    }
  };

  const cancelWarehouseEdit = () => {
    setIsWarehouseEditMode(false);
    // Reset warehouse data to original values from form fields
    setWarehouseData({
      warehouse_name: $("#warehouse_name").val() || '',
      code: $("#wcode").val() || '',
      addr1: $("#addr1").val() || '',
      addr2: $("#addr2").val() || '',
      city: $("#city").val() || '',
      state: $("#state").val() || '',
      country: $("#country").val() || '',
      postcode: $("#postcode").val() || ''
    });
  };

  useEffect(() => {

  }, [grnItems]);

  useEffect(() => {
    if (grnItems.length > 0) {
      // Check if PO is partial: total received (existing GRN + new batch quantity) < order quantity
      const isPartial = grnItems.some(item => {
        const existingGRN = Number(item.grn) || 0;
        const newBatchQty = Number(item.batchQty) || 0;
        const totalReceived = existingGRN + newBatchQty;
        const orderQty = Number(item.order_qty) || 0;
        return totalReceived < orderQty;
      });
      setCanSavePartial(isPartial);
    }
  }, [grnItems]);




  return (
    <div>
      <div className="modal fade" id="crn-add-product" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">&nbsp;</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="partialbox">
                <div className="row mb-3">
                  <label htmlFor="inputText" className="col-sm-6 col-form-label">Search (Code/Name/Unit Barcode)</label>
                  <div className="col-sm-6">
                    <input type="text" className="search-area" placeholder="Search" autoComplete="off" value="" />
                  </div>
                </div>
                <table className="table table-bordered dataTable">
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Name</th>
                      <th>PK</th>
                      <th>Size</th>
                      <th>Unit Barcode</th>
                      <th>Stock</th>
                      <th>F.STK</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><a href="#" target="_blank">SKI010</a></td>
                      <td>Skittles Crazy Sours</td>
                      <td>36</td>
                      <td>45GM</td>
                      <td>&nbsp;</td>
                      <td>324</td>
                      <td>176</td>
                    </tr>
                    <tr>
                      <td><a href="#" target="_blank">SKI010</a></td>
                      <td>Skittles Crazy Sours</td>
                      <td>36</td>
                      <td>45GM</td>
                      <td>&nbsp;</td>
                      <td>324</td>
                      <td>176</td>
                    </tr>
                    <tr>
                      <td><a href="#" target="_blank">SKI010</a></td>
                      <td>Skittles Crazy Sours</td>
                      <td>36</td>
                      <td>45GM</td>
                      <td>&nbsp;</td>
                      <td>324</td>
                      <td>176</td>
                    </tr>
                    <tr>
                      <td><a href="#" target="_blank">SKI010</a></td>
                      <td>Skittles Crazy Sours</td>
                      <td>36</td>
                      <td>45GM</td>
                      <td>&nbsp;</td>
                      <td>324</td>
                      <td>176</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="savepartial" tabIndex="-1" ref={confirmModal} >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">&nbsp;</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="add-product-popup">
                <h3>Save Partial Purchase Order?</h3>
                <hr />
                {canSavePartial && (
                  <a href="#" onClick={(e) => handleConfirmGRN(e, 'Partial', confirmModal, navigateToPOHistory)} className="popup-innerbtn-common">Save Partial</a>

                )}
                <a href="#" onClick={(e) => handleConfirmGRN(e, 'Close', confirmModal, navigateToPOHistory)} className="popup-innerbtn-closebtn">Complete Purchase Order</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Header />
      <ViewProduct product_id={selectedProductId}/>
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12"> <a href="#"><i className="fa fa-home"></i></a> &gt; <a href="/dashboard">Dashboard</a> &gt; <a href="/GRN">Current Purchase Order</a> &gt; <span className="last-crumb">Complete Purchase Order</span> </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <form id='confirm_grn'>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg-12 col-sm-12">
                <div className="dashboard">
                  <div className="">
                    <div className="dashform">
                      <div className="topsearch-area">
                        <div className="row">
                          <div className="col-12 col-lg-3 col-sm-3">
                            <div className="row">
                              <label htmlFor="inputText" className="col-sm-4 col-form-label" > Supplier: </label>
                              <div className="col-sm-8">
                                <select
                                  name="supplier_id"
                                  className="form-select"
                                  value={preSupplierData || ''}
                                  onChange={(e) => setPreSupplierData(e.target.value)}
                                >
                                  <option value="">Select Supplier</option>
                                  {supplierData && supplierData.length > 0 ? (
                                    supplierData.map((supplier) => (
                                      <option key={supplier.id} value={supplier.id}>
                                        {supplier.name}
                                      </option>
                                    ))
                                  ) : (
                                    <option value="" disabled>Loading suppliers...</option>
                                  )}
                                </select>

                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-lg-3 col-sm-3">
                            <div className="row">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ProductBatch onViewPastPurchase={(showModal) => { productBatchRef.current = showModal; }} getProductBatchData={getProductBatchData}
                      modalData={modalData} />

                    <div className="verical-scrl-wrapper common-table confirm-grn-tbl" id="style-3">
                      <table className="table table-bordered dataTable" id="dsTable">
                        <thead>
                          <tr>
                            <th>Code</th>
                            <th>Expiry</th>
                            <th>Description</th>
                            <th>Pk</th>
                            <th>Size</th>
                            <th>Order Qty</th>
                            <th>Received Qty</th>
                            <th>GRN</th>
                            <th>CurStock</th>
                            <th>On S.O</th>
                            <th>FStk</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {grnItems.map((row, rowIndex) => (
                            <tr key={row.id}>
                              <td>
                                <input type="hidden" name="product_id[]" value={row.product_id} />
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    getProductBatchData(row.product_id);
                                  }}
                                >
                                  {row.code}
                                </Link>
                              </td>
                              <td>

                                {batchData.map((item, index) => (
                                  row.product_id === item.product_id && (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', flexWrap: 'nowrap', gap: '2px', width: '100%' }}>
                                      <CustomDateInput
                                        name={`expiry_date_${row.product_id}_${index}`}
                                        id={`expiry_date_${row.product_id}_${index}`}
                                        className="form-control expiryDate"
                                        value={item.expiry_date}
                                        onChange={(e) => handleChange(e, index, 'expiryDate')}
                                        style={{ flexShrink: 0 }}
                                      />
                                      <input
                                        type="text"
                                        className="form-control batchQty qtyinputbox"
                                        name={`batch_qty_${row.product_id}_${index}`}
                                        placeholder="Qty"
                                        value={item.qty || ''}
                                        onChange={(e) => handleChange(e, index, 'batchQty')}
                                        style={{ flexShrink: 0, display: 'inline-block', visibility: 'visible', width: '70px', minWidth: '70px', maxWidth: '70px' }}
                                      />
                                    </div>
                                  )
                                ))}

                                {row.expiryData.map((data, index) =>
                                  row.order_qty === row.grn ? null : (
                                    <div
                                      key={index}
                                      style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', flexWrap: 'nowrap', gap: '2px', width: '100%' }}
                                    >
                                      <CustomDateInput
                                        name={`expiry_${row.product_id}[]`}
                                        id={`expiry_${row.product_id}_${index}`}
                                        className="form-control expiryDate"
                                        value={data.expiryDate}
                                        onChange={(e) =>
                                          handleExpiryDataChange(e, row.id, index, 'expiryDate')
                                        }
                                        style={{ flexShrink: 0 }}
                                      />
                                      <input
                                        type="text"
                                        className="form-control batchQty qtyinputbox"
                                        name={`batch_qty_${row.product_id}[]`}
                                        placeholder="Qty"
                                        value={data.batchQty || ''}
                                        onChange={(e) =>
                                          handleExpiryDataChange(e, row.id, index, 'batchQty')
                                        }
                                        style={{ flexShrink: 0, display: 'inline-block', visibility: 'visible', width: '70px', minWidth: '70px', maxWidth: '70px' }}
                                      />
                                      {index !== 0 && (
                                        <button
                                          type="button"
                                          onClick={() => removeExpiryData(row.id, index)}
                                          style={{ color: 'red', cursor: 'pointer', background: 'none', border: 'none', fontSize: '18px', padding: '0 5px', flexShrink: 0 }}
                                        >
                                          &#10005;
                                        </button>
                                      )}
                                      <div className="button_for_addmore" style={{ flexShrink: 0 }}>
                                        <button type="button" onClick={() => addExpiryData(row.id)} style={{ background: '#28a745', color: '#fff', border: 'none', borderRadius: '3px', padding: '2px 8px', cursor: 'pointer', whiteSpace: 'nowrap' }}>+</button>
                                      </div>
                                    </div>
                                  )
                                )}

                              </td>
                              <td>
                                <p className="cut-text">
                                  <a
                                    data-bs-toggle="modal"
                                    className="applybtn"
                                    data-id={row.product_id}
                                    data-bs-target="#viewproduct"
                                    onClick={() => setSelectedProductId(row.product_id)}

                                  >
                                    {row.product_desc}
                                  </a>
                                </p>
                              </td>
                              <td> {row.pack}</td>
                              <td> {row.size}</td>
                              <td><input type="hidden" name="order_qty[]" value={row.order_qty} /> {row.order_qty} </td>
                              <td><input type="text" readOnly id="received_qty" name="received_qty[]" autoComplete='off' value={row.batchQty}
                                className="form-control qtyinputbox" onChange={(e) => handleInputChange(e, row.id, row.grn, "received_qty", setGRNItems, grnItems, row.newlyAdded, row.order_qty)} /></td>
                              <td>{row.grn}</td>
                              <td><input type="hidden" name="currrent_stock[]" value={row.current_stock} />{row.current_stock}</td>
                              <td><input type="hidden" name="onSO[]" value="0" />{row.on_so}</td>
                              <input type="hidden" name="price[]" value={row.price} />
                              <input type="hidden" name="cost[]" value={row.cost} />
                              <input type="hidden" name="grn[]" value={row.grn} />
                              <input
                                type="hidden"
                                name="vatPercentage[]"
                                value={row.vat_percentage}
                              />
                              <td><input type="hidden" name="fstk[]" value="0" />{row.free_stock}</td>
                              <td>
                                <a href="#" value="Remove" onClick={() => removeRow(row.id, setGRNItems)}>
                                  <i className="fa fa-trash"></i>
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="purchaseform">
                      <input type="hidden" name="stdGoods" value={Number(stdGoods).toFixed(2)} />
                      <input type="hidden" name="vatAmt" value={Number(vatAmt).toFixed(2)} />
                      <input type="hidden" name="zeroGoods" value={Number(zeroGoods).toFixed(2)} />
                      <input type="hidden" name="grandTotal" value={Number(grandTotal).toFixed(2)} />
                      <input type="hidden" name="warehouse_id" id='warehouse_id' />
                      <input type="hidden" name="purchase_id" id='purchase_id' />
                      <input type="hidden" name="delivery_type" id='delivery_type' />


                      <div className="row">
                        <div className="col-6 col-lg-6 col-sm-6">

                          <div className="row mb-3">
                            <div className="col-3 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Date of Arrival </label>
                            </div>
                            <div className="col-3 col-lg-3 col-sm-3">
                              <CustomDateInput
                                name="arrival_date"
                                id="arrival_date"
                                value={formData.arrival_date}
                                onChange={(e) => handleFormDataChange('arrival_date', e.target.value)}
                              />
                            </div>
                            <div className="col-3 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label padd-left-50">Job Ref <span className="red">*</span></label>
                            </div>
                            <div className="col-3 col-lg-3 col-sm-3">
                              <input
                                type="text"
                                className="form-control"
                                name="job_ref"
                                id="job_ref"
                                value={formData.job_ref}
                                maxLength={50}
                                onChange={(e) => handleFormDataChange('job_ref', e.target.value)}
                              />
                              {fieldErrors.job_ref && <span style={{ color: 'red', fontSize: '12px' }}>{fieldErrors.job_ref}</span>}
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-6 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Notes </label>
                            </div>
                            <div className="col-6 col-lg-9 col-sm-9">
                              <textarea
                                className="form-control"
                                name="notes"
                                id="notes"
                                value={formData.notes}
                                maxLength={500}
                                onChange={(e) => handleFormDataChange('notes', e.target.value)}
                              ></textarea>
                              {fieldErrors.notes && <span style={{ color: 'red', fontSize: '12px' }}>{fieldErrors.notes}</span>}
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-lg-6 col-sm-6">
                          <div className="row mb-3">
                            <div className="col-12 col-lg-12 col-sm-12">
                              {(purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer !== 'customer') && (
                                <label htmlFor="desc" className="col-form-label" style={{ float: 'left' }}>Delivery Address (of Warehouse)</label>
                              )}
                              {(purchaseData.delivery_type === 'collection') && (
                                <label htmlFor="desc" className="col-form-label" style={{ float: 'left' }}>Collection Address</label>
                              )}
                              {(purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'customer') && (
                                <label htmlFor="desc" className="col-form-label" style={{ float: 'left' }}>Customer Delivery Address</label>
                              )}
                            </div>
                          </div>

                          {(purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer !== 'customer') && (
                            <div className="row mb-3">
                              <div className="col-3 col-lg-3 col-sm-3">
                                <label htmlFor="warehouse_name" className="col-form-label">Warehouse Name</label>
                              </div>
                              <div className="col-6 col-lg-3 col-sm-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="warehouse_name"
                                  name="warehouse_name"
                                  value={warehouseData.warehouse_name}
                                  maxLength={50}
                                  onChange={(e) => handleWarehouseChange('warehouse_name', e.target.value)}
                                />
                              </div>
                              <div className="col-6 col-lg-3 col-sm-3">
                                <label htmlFor="wcode" className="col-form-label padd-left-50">Code</label>
                              </div>
                              <div className="col-6 col-lg-3 col-sm-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="wcode"
                                  name="wcode"
                                  value={warehouseData.code}
                                  maxLength={50}
                                  onChange={(e) => handleWarehouseChange('code', e.target.value)}
                                />
                              </div>
                            </div>
                          )}

                          <div className="row mb-3">
                            <div className="col-6 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Address Line 1 </label>
                            </div>
                            <div className="col-8 col-lg-9 col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                id="addr1"
                                name="addr1"
                                value={purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse' ? warehouseData.addr1 : deliveryAddress.addr1}
                                maxLength={50}
                                onChange={(e) => {
                                  if (purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse') {
                                    handleWarehouseChange('addr1', e.target.value);
                                  } else {
                                    handleAddressChange('addr1', e.target.value);
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div div className="row mb-3">
                            <div className="col-6 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Address Line 2 </label>
                            </div>
                            <div className="col-8 col-lg-9 col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                id="addr2"
                                name="addr2"
                                value={purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse' ? warehouseData.addr2 : deliveryAddress.addr2}
                                maxLength={50}
                                onChange={(e) => {
                                  if (purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse') {
                                    handleWarehouseChange('addr2', e.target.value);
                                  } else {
                                    handleAddressChange('addr2', e.target.value);
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-6 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">City </label>
                            </div>
                            <div className="col-6 col-lg-3 col-sm-3">
                              <input
                                type="text"
                                className="form-control"
                                id="city"
                                name="city"
                                value={purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse' ? warehouseData.city : deliveryAddress.city}
                                maxLength={50}
                                onChange={(e) => {
                                  if (purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse') {
                                    handleWarehouseChange('city', e.target.value);
                                  } else {
                                    handleAddressChange('city', e.target.value);
                                  }
                                }}
                              />
                            </div>
                            <div className="col-6 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label padd-left-50">County </label>
                            </div>
                            <div className="col-6 col-lg-3 col-sm-3">
                              <input
                                type="text"
                                className="form-control"
                                id="state"
                                name="state"
                                value={purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse' ? warehouseData.state : deliveryAddress.state}
                                maxLength={50}
                                onChange={(e) => {
                                  if (purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse') {
                                    handleWarehouseChange('state', e.target.value);
                                  } else {
                                    handleAddressChange('state', e.target.value);
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-6 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Country </label>
                            </div>
                            <div className="col-6 col-lg-3 col-sm-3">
                              <input
                                type="text"
                                className="form-control"
                                id="country"
                                name="country"
                                value={purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse' ? warehouseData.country : deliveryAddress.country}
                                maxLength={50}
                                onChange={(e) => {
                                  if (purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse') {
                                    handleWarehouseChange('country', e.target.value);
                                  } else {
                                    handleAddressChange('country', e.target.value);
                                  }
                                }}
                              />
                            </div>
                            <div className="col-6 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label padd-left-50">Post Code </label>
                            </div>
                            <div className="col-6 col-lg-3 col-sm-3">
                              <input
                                type="text"
                                className="form-control"
                                id="postcode"
                                name="postcode"
                                value={purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse' ? warehouseData.postcode : deliveryAddress.postcode}
                                maxLength={50}
                                onChange={(e) => {
                                  if (purchaseData.delivery_type !== 'collection' && purchaseData.is_wharehouse_or_customer === 'warehouse') {
                                    handleWarehouseChange('postcode', e.target.value);
                                  } else {
                                    handleAddressChange('postcode', e.target.value);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-lg-12 col-sm-12">
                          <hr />
                        </div>
                        <div className="col-6 col-lg-12 col-sm-12">
                          <a 
                            href="#" 
                            className="popup-innerbtn-common right" 
                            onClick={(e) => {
                              e.preventDefault();
                              const validation = validateConfirmGrnForm();
                              if (!validation.valid) {
                                setFieldErrors((prev) => ({ ...prev, job_ref: validation.message }));
                                Swal.fire({
                                  title: 'Error!',
                                  text: validation.message,
                                  icon: 'error',
                                  timer: 2500,
                                  showConfirmButton: false,
                                });
                                return;
                              }
                              if (canSavePartial) {
                                const modalElement = document.getElementById('savepartial');
                                if (modalElement) {
                                  const bsModal = new window.bootstrap.Modal(modalElement);
                                  bsModal.show();
                                }
                              } else {
                                handleConfirmGRN(e, 'Close', confirmModal, navigateToPOHistory);
                              }
                            }}
                          >
                            Complete Purchase Order
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default ConfirmGRN; 
